export default __webpack_public_path__ + "static/media/blue_teamwork.a150e17a.svg";